<template>
  <div class="container">
    <div class="inner-container">
      <h2 class="title">产品介绍</h2>
      <div class="picture-container">
        <el-image class="picture"
                  :src="active.img"
                  fit="fill"> </el-image>
        <!-- <el-input
          class="input-search"
          suffix-icon="el-icon-search"
          v-model="active.content"
          disabled
        >
        </el-input> -->
        <div style="display: flex">
          <div class="search-item"
               v-for="(item, index) in titleList"
               :key="index">
            <div class="inner-item-container"
                 @click="handleChoose(item.key)">
              <div class="search-item-image-container"
                   :class="{ activeimage: item.key === active.key }">
                <el-image class="search-item-image"
                          :src="item.src"
                          fit="fill"></el-image>
              </div>
              <h3 class="search-item-title"
                  :class="{ activetitle: item.key === active.key }">
                {{ item.title }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <h2 class="title"
          style="margin-top: 62px">产品优势</h2>
      <div style="
          background: #fff;
          margin-top: 24px;
          border-radius: 26px;
          padding: 78px 30px 90px 30px;
          display: flex;
        ">
        <div class="advantage-item"
             v-for="(item, index) in advantageImage"
             :key="index">
          <div>
            <el-image class="advantage-item-image"
                      :src="item.src"
                      fit="fill"></el-image>
          </div>
          <h3 class="advantage-item-title">{{ item.title }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: null,
      imgList: {
        1: {
          img: require('@/assets/img/service/location/image-map-revercode.png'),
          key: 1
        }
      },
      titleList: [
        {
          title: '将美团经纬度坐标转化为详细的结构化地址',
          src: require('@/assets/img/service/location/icon-code.svg'),
          key: 1
        }
      ],
      advantageImage: [
        {
          title: '精准转化',
          src: require('@/assets/img/service/location/image_1.png')
        },
        {
          title: '海量 POI 数据',
          src: require('@/assets/img/service/location/image_2.png')
        },
        {
          title: '海量 AOI 数据',
          src: require('@/assets/img/service/location/image_3.png')
        }
      ]
    };
  },
  methods: {
    handleChoose(item) {
      this.active = this.imgList[item];
    }
  },
  created() {
    this.active = this.imgList[1];
  }
};
</script>
<style lang="less" scoped>
.container {
  // background-image: linear-gradient(0deg, rgba(255,255,255,0.00) 0%, #F7F7F7 100%);
  background-color: #f7f7f7;
  display: flex;
  justify-content: center;
  padding: 60px 0;
  background-image: linear-gradient(
    0deg,
    rgba(255, 255, 255, 0) 0%,
    #f7f7f7 100%
  );
  .inner-container {
    width: 1200px;
    .title {
      font-family: PingFangSC-Semibold;
      font-size: 36px;
      color: rgba(0, 0, 0, 0.84);
      font-weight: 600;
      line-height: 50px;
    }
    .picture-container {
      position: relative;
      margin-top: 24px;
      height: 518;
      border-radius: 26px;
      background-color: #fff;
      .picture {
        height: 408px;
        width: 100%;
      }
      .input-search {
        width: 340px;
        position: absolute;
        left: 36px;
        top: 36px;
        font-size: 18px;
        color: rgba(0, 0, 0, 0.84);
        font-family: PingFangSC-Regular;
        font-weight: 400;
        line-height: 25px;
        letter-spacing: 0;
        /deep/ .el-input__inner {
          /*或者 .s2>>>.el-input__inner  */
          height: 48px; /*调整inner的高度*/
          border-radius: 12px; /*输入框圆角值*/
          border: none;
        }
      }
      .search-item {
        flex: 1;
        background: #ffffff;
        display: flex;
        justify-content: center;
        .inner-item-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 100%;
          .search-item-image-container {
            margin-top: 6px;
            width: 58px;
            height: 58px;
            border-radius: 29px;
            display: flex;
            justify-content: center;
            align-items: center;
            .search-item-image {
              width: 36px;
              height: 36px;
            }
          }

          .activeimage {
            background-image: linear-gradient(-45deg, #ffe75f 0%, #ffd100 100%);
          }
          .search-item-title {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.84);
            margin-top: 3px;
            margin-bottom: 17px;
            letter-spacing: 0;
            font-weight: 400;
            line-height: 20px;
          }
          .activetitle {
            font-family: PingFangSC-Medium;
            color: rgba(0, 0, 0, 1);
            font-weight: 500;
          }
        }
        .inner-item-container:hover {
          .search-item-image-container {
            background-color: rgba(0, 0, 0, 0.03);
          }
        }
      }

      .search-item:first-of-type {
        border-radius: 0 0 0 26px;
      }
      .search-item:last-of-type {
        border-radius: 0 0 26px 0;
      }
    }
    .advantage-item {
      height: 148px;
      padding-top: 12px;
      flex: 1;
      text-align: center;
      background: #ffffff;
      .advantage-item-image {
        width: 90px;
        height: 90px;
      }
      .advantage-item-title {
        margin-top: 4px;
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #000;
        font-weight: 500;
        text-align: center;
        line-height: 25px;
      }
    }
  }
}
</style>
